import React from "react";
import { Redirect } from "react-router-dom";
import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import { useClient } from "frontend/src/domain/client";
import { useViewer } from "frontend/src/domain/session";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { paths } from "frontend/src/pages/paths";
var useStyles = makeStyles(function (theme) { return ({
    panel: {
        height: "100%",
        padding: theme.spacing(2),
        borderRadius: 8,
        boxShadow: "none",
        border: "1px solid " + theme.palette.divider,
    },
    detailsTable: {
        borderCollapse: "collapse",
        "& .MuiTableCell-root": {
            border: "1px solid " + theme.palette.divider,
            paddingTop: 4,
            paddingBottom: 4,
        },
    },
    detailsLabel: {
        width: "50%",
        fontWeight: 700,
    },
    detailsValue: {
        textAlign: "center",
    },
}); });
var DetailsRow = function (_a) {
    var label = _a.label, value = _a.value;
    var classes = useStyles();
    return (React.createElement(TableRow, null,
        React.createElement(TableCell, { className: classes.detailsLabel }, label),
        React.createElement(TableCell, { className: classes.detailsValue }, value || "-")));
};
export var ClientDetailsPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var classes = useStyles();
    var user = useViewer().user;
    var client = useClient(user === null || user === void 0 ? void 0 : user.clientId);
    if (client.isFetched && !((_a = client.data) === null || _a === void 0 ? void 0 : _a.showDetails)) {
        return React.createElement(Redirect, { to: paths.business.owner.home() });
    }
    var legalEntity = (_b = client.data) === null || _b === void 0 ? void 0 : _b.russianLegalEntity;
    var sites = (_d = (_c = client.data) === null || _c === void 0 ? void 0 : _c.sites) !== null && _d !== void 0 ? _d : [];
    return (React.createElement(BusinessOwnerLayout, null,
        React.createElement(Box, { mb: 3 },
            React.createElement(Typography, { variant: "h4", component: "h1" }, "\u041C\u043E\u0438 \u0434\u0430\u043D\u043D\u044B\u0435")),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Paper, { className: classes.panel },
                    React.createElement(Box, { mt: 2 }, client.isLoading ? (React.createElement(Skeleton, null)) : (React.createElement(TableContainer, null,
                        React.createElement(Table, { size: "small", className: classes.detailsTable },
                            React.createElement(TableBody, null,
                                React.createElement(DetailsRow, { label: "Личный кабинет", value: (_f = (_e = client.data) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f.name }),
                                React.createElement(DetailsRow, { label: "Юридическое лицо", value: legalEntity === null || legalEntity === void 0 ? void 0 : legalEntity.title }),
                                React.createElement(DetailsRow, { label: "ИНН", value: legalEntity === null || legalEntity === void 0 ? void 0 : legalEntity.inn }),
                                React.createElement(DetailsRow, { label: "ОГРН", value: legalEntity === null || legalEntity === void 0 ? void 0 : legalEntity.ogrn }),
                                React.createElement(DetailsRow, { label: "Номер договора", value: (_g = client.data) === null || _g === void 0 ? void 0 : _g.contractNumber }),
                                React.createElement(DetailsRow, { label: "Дата договора", value: (_h = client.data) === null || _h === void 0 ? void 0 : _h.contractDate }),
                                React.createElement(DetailsRow, { label: "Почта клиента", value: (_k = (_j = client.data) === null || _j === void 0 ? void 0 : _j.user) === null || _k === void 0 ? void 0 : _k.email })))))))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Paper, { className: classes.panel },
                    React.createElement(Typography, { variant: "h6" }, "\u0410\u0434\u0440\u0435\u0441\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F"),
                    React.createElement(Box, { mt: 2 }, client.isLoading ? (React.createElement(Skeleton, null)) : sites.length > 0 ? (React.createElement(TableContainer, null,
                        React.createElement(Table, { size: "small" },
                            React.createElement(TableHead, null,
                                React.createElement(TableRow, null,
                                    React.createElement(TableCell, null, "\u0410\u0434\u0440\u0435\u0441"))),
                            React.createElement(TableBody, null, sites.map(function (site) { return (React.createElement(TableRow, { key: site.id },
                                React.createElement(TableCell, null, site.name))); }))))) : (React.createElement(Typography, { color: "textSecondary" }, "\u0410\u0434\u0440\u0435\u0441\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043D\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B."))))))));
};
